import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxCollection,
  RxDocument,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'
import { formatPrice } from 'src/lib/util/format-utils'

export const quoteSchemaLiteral = {
  title: 'Quote Schema',
  description: 'Describes a quote',
  version: 0,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    title: {
      type: 'string',
    },
    introduction: {
      type: ['string', 'null'],
    },
    validUntil: {
      type: ['string', 'null'],
    },
    resources: {
      type: 'array',
      ref: 'resources',
      items: {
        type: 'string',
      },
    },
    data: {
      type: ['object', 'null'],
      additionalProperties: true,
    },
    value: {
      type: 'number',
    },
    createdAt: {
      type: ['string', 'null'],
    },
    updatedAt: {
      type: ['string', 'null'],
    },
  },
  required: ['id', 'value'],
  indexes: [],
} as const

const schemaTyped = toTypedRxJsonSchema(quoteSchemaLiteral)

export type QuoteDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const quoteSchema: RxJsonSchema<QuoteDocType> = schemaTyped

export type QuoteDocMethods = {
  getFormattedValue(): string
}

export const quoteDocMethods = {
  getFormattedValue(): string {
    return formatPrice(this.value)
  },
}

export type QuoteDocument = RxDocument<QuoteDocType, QuoteDocMethods>

export type QuoteCollectionMethods = {
  //
}

export type QuoteCollection = RxCollection<QuoteDocType, QuoteDocMethods, QuoteCollectionMethods>
